import React from 'react';
import "./agileConnection.scss";

//Imagens:
import ImgAgileConnection from "../../../../assets/dataManagement/agileConnection.png"

import Section from '../../../../components/utils/SectionComponent'
import { useTranslation } from 'react-i18next';

function AgileConnection({ title, children }) {
    const { t } = useTranslation()

    return (
        <div className='container-agile-connection'>
            <div className='img-agile'>
                <img src={ImgAgileConnection} alt="" />
            </div>
            <div className='texts-agile'>
                <Section title={title}>
                    {children}
                </Section>
            </div>
        </div>
    )
}

export default AgileConnection;